import React, { useEffect, useState } from 'react';
import './DuelistListPage.css';
import { db } from '../firebase';
import { collection, getDocs, query, orderBy } from 'firebase/firestore';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { playSound } from '../utils/soundPlayer';

const DuelistListPage = () => {
  const [duelists, setDuelists] = useState([]);
  const { t } = useTranslation();
  const navigate = useNavigate();


  useEffect(() => {
    const fetchDuelists = async () => {
      const q = query(collection(db, 'users'));
      const snapshot = await getDocs(q);
      const users = snapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));
      
      // Sort by YP (descending), then by matches (descending)
      const sortedUsers = users.sort((a, b) => {
        const aYP = a.YP || 0;
        const bYP = b.YP || 0;
        
        if (aYP !== bYP) {
          return bYP - aYP; // Higher YP first
        }
        
        // If YP is the same, sort by matches
        const aMatches = a.stats?.matches || 0;
        const bMatches = b.stats?.matches || 0;
        return bMatches - aMatches; // Higher matches first
      });
      
      setDuelists(sortedUsers);
    };

    fetchDuelists();
  }, []);

  return (
    <div className="duelist-list-container">
      <h1 >{t('duelists.title')}</h1>
      <div className="duelist-list">
        {duelists.map((user, index) => {
          // Calculate rank based on position in sorted list
          const rank = index + 1;
          
          // Determine division based on rank
          let division = 'Red Slifer';
          if (rank >= 1 && rank <= 4) {
            division = 'Blue Obelisk';
          } else if (rank >= 5 && rank <= 12) {
            division = 'Yellow Ra';
          }
          
          const isUnranked = String(user.division).toLowerCase() === 'unranked';

          let divisionClass = '';
          const divisionValue = division.toLowerCase();
          if (divisionValue === 'unranked') {
            divisionClass = 'red'; // Force unranked to use Slifer styling
          } else if (divisionValue.includes('obelisk')) {
            divisionClass = 'blue';
          } else if (divisionValue.includes('ra')) {
            divisionClass = 'yellow';
          } else if (divisionValue.includes('slifer')) {
            divisionClass = 'red';
          }


          return (
            <div
              key={user.id}
              className={`duelist-card ${divisionClass === 'blue'
                ? 'obelisk-glow'
                : divisionClass === 'yellow'
                  ? 'ra-glow'
                  : divisionClass === 'red'
                    ? 'slifer-border'
                    : ''
                }`}

              onClick={() => navigate(`/profile/${user.id}`)}
              style={{ cursor: 'pointer' }}
            >
              <div className="duelist-left">
                <span className={`duelist-rank ${divisionClass}`}>#{rank}</span>
                <img
                  onMouseDown={(e) => e.button === 2 && e.preventDefault()}
                  onTouchStart={(e) => e.preventDefault()}
                  draggable={false}
                  className="duelist-avatar"
                  src={user.profilePicture || '/default-avatar.png'}
                  alt="avatar"
                />
                <div className="duelist-info">
                  <p className="duelist-name">{user.pseudo}</p>
                  <p className={`duelist-division ${divisionClass}`}>
                    {division}
                  </p>
                </div>
              </div>
              <div className="duelist-yp">
                {user.YP !== undefined ? `YP: ${user.YP}` : ''}
              </div>

            </div>
          );
        })}
      </div>
      <button
        className="back-button"
        onClick={() => {
          playSound('return');
          navigate('/menu');
        }}
      >
        {t('leaderboard.back')}
      </button>
    </div>
  );
};

export default DuelistListPage;
